(function () {
  if (window.CEOOUDReviewCarouselLoaded) return;
  window.CEOOUDReviewCarouselLoaded = true;

  var rootSelector = '.ceooud-review-carousel';
  var trackSelector = '.jdgm-rev-widg__reviews';

  function createArrow(label, direction) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ceooud-review-carousel__arrow ceooud-review-carousel__arrow--' + direction;
    button.setAttribute('aria-label', label);
    button.innerHTML = direction === 'previous'
      ? '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="M15 18 9 12l6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return button;
  }

  function setupCarousel(root) {
    var track = root.querySelector(trackSelector);
    if (!track || track.dataset.ceooudCarouselReady === 'true') return false;

    var firstCard = track.querySelector('.jdgm-rev');
    if (!firstCard) return false;

    var cardCount = track.querySelectorAll('.jdgm-rev').length;
    root.classList.add('ceooud-review-carousel--count-' + Math.min(cardCount, 3));

    track.dataset.ceooudCarouselReady = 'true';
    track.setAttribute('role', 'region');
    track.setAttribute('aria-label', 'Customer reviews carousel');
    track.setAttribute('tabindex', '0');

    var body = track.parentElement;
    if (!body) return false;
    body.classList.add('ceooud-review-carousel__body');

    var nav = document.createElement('div');
    nav.className = 'ceooud-review-carousel__nav';

    var previous = createArrow('Previous review', 'previous');
    var next = createArrow('Next review', 'next');
    nav.appendChild(previous);
    nav.appendChild(next);
    body.insertBefore(nav, track);

    function stepSize() {
      var card = track.querySelector('.jdgm-rev');
      if (!card) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function refreshControls() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      nav.hidden = maxScroll < 2;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    }

    previous.addEventListener('click', function () {
      track.scrollBy({ left: -stepSize(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: stepSize(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', refreshControls, { passive: true });
    window.addEventListener('resize', refreshControls, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(refreshControls).observe(track);
    }

    refreshControls();
    window.setTimeout(refreshControls, 250);
    return true;
  }

  function setupRoot(root) {
    if (setupCarousel(root)) return;
    if (!('MutationObserver' in window)) return;

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        if (setupCarousel(root)) observer.disconnect();
      });
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function start() {
    document.querySelectorAll(rootSelector).forEach(setupRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
